import classNames from "classnames";
import { useGetTaskQuery } from "store/apis/task";

export const FilingStatusBadge = ({ taskId }: { taskId: string }) => {
  const { data: task } = useGetTaskQuery({ taskId });

  const taskState = typeof task?.state === "object" ? task.state : null;
  const isFinal = Boolean(taskState?.is_final);
  const label = taskState?.name || "Filing in progress";

  return (
    <div
      className={classNames(
        "t-text-text-60 t-max-w-fit t-text-body-sm t-text-center t-px-2 t-py-1 t-text-nowrap t-rounded-md",
        {
          "t-bg-green-20": isFinal,
          "t-bg-blue-10": !isFinal,
        }
      )}
    >
      <span>{label}</span>
    </div>
  );
};
